var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.357,
    height: 52.281,
    viewBox: "0 0 43.357 52.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(-48.139 -910.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M79.435,963.166a23.138,23.138,0,0,1-8.748-3.579,47.289,47.289,0,0,1-10.595-9.625A57.086,57.086,0,0,1,50.2,933.268a29.978,29.978,0,0,1-2.059-9.843,15.337,15.337,0,0,1,.582-4.808,6.811,6.811,0,0,1,2.428-3.215,29.444,29.444,0,0,1,7.486-4.273,1.7,1.7,0,0,1,2.074.6q2.922,4.048,5.81,8.124a1.791,1.791,0,0,1-.517,2.539c-1.35.95-2.71,1.884-4.07,2.819-1.79,1.231-1.939,1.447-1.858,3.667a22.177,22.177,0,0,0,8.089,16.532,19.019,19.019,0,0,0,6.874,3.889c.082.026.163.057.247.075,2.177.463,1.588.521,3.217-.622,1.409-.99,2.788-2.023,4.183-3.033a1.827,1.827,0,0,1,2.773.434q2.8,3.9,5.6,7.8a1.768,1.768,0,0,1,0,2.336,29.236,29.236,0,0,1-6.328,5.662,7.107,7.107,0,0,1-3.679,1.317C80.4,963.281,79.761,963.189,79.435,963.166Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.a8cf146d37e0ee1e0c8438f8db19b7d7.svg";
export { ForwardRef as ReactComponent };